{
  "propertyManager": "Isännöitsijä",
  "propertyMaintenance": "Kiinteistöhuolto",
  "customerService": "Asiakaspalvelu",
  "residentsCommittee": "Asukastoimikunta",
  "contactInformation": "Yhteystiedot",
  "contactMaintenanceOrManager": "Otanko yhteyttä isännöitsijään vai kiinteistöhuoltoon?",
  "call": "Soita",
  "email": "Lähetä sähköpostia",
  "errors": {
    "title": "Virhe",
    "failedToLoadContacts": "Yhteystietojen lataamisessa tapahtui virhe. Yritä myöhemmin uudelleen."
  },
  "democracyRoles": {
    "chairperson": "Puheenjohtaja",
    "vice_chairperson": "Varapuheenjohtaja",
    "member": "Jäsen",
    "treasurer": "Rahastonhoitaja",
    "secretary": "Sihteeri",
    "contact_person": "Yhteyshenkilö",
    "representative": "Luottamushenkilö",
    "board_member": "Hallituksen asukasjäsen",
    "supervisor": "Valvoja"
  },
  "legal": {
    "privacyStatementLinkText": "Tietosuojaseloste",
    "accessibilityStatementLinkText": "Saavutettavuusseloste",
    "termsOfUseLinkText": "Käyttöehdot",
    "privacyStatementLink": "https://mikkelinasumisoikeus.fi/evastekaytanto-eu/",
    "accessibilityStatementLink": "https://mikkelinasumisoikeus.fi/evastekaytanto-eu/",
    "termsOfUseLink": "https://mikkelinasumisoikeus.fi/evastekaytanto-eu/"
  },
  "question": {
    "title": "Kysy asumisesta",
    "description": "Tällä lomakkeella voit kysyä meiltä asumiseen liittyvistä asioista. Pyrimme vastaamaan muutaman päivän kuluessa.",
    "button": "Kysy asumisesta"
  },
  "feedback": {
    "title": "Anna palautetta",
    "description": "Tällä lomakkeella voit antaa palautetta taloyhtiölle, tai huoltoyhtiölle. Palaamme tarvittaessa asiaan noin 10 arkipäivän kuluessa.",
    "button": "Anna palautetta"
  }
}